// Product / inventory client helpers
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Category metadata: slug -> labels + fallback image (served from frontend /uploads)
export const CATEGORY_META = {
  laptops: { en: "Laptops", es: "Laptops", image: "/uploads/PHOTO-2026-05-16-11-00-24.jpg" },
  notebooks: { en: "Notebooks", es: "Notebooks", image: "/uploads/PHOTO-2026-05-20-15-14-03.jpg" },
  desktops: { en: "Desktops", es: "Computadoras de Escritorio", image: "/uploads/PHOTO-2026-05-28-14-53-55.jpg" },
  "all-in-one": { en: "All-in-One", es: "Todo en Uno", image: "/uploads/PHOTO-2026-05-28-14-53-55.jpg" },
  sff: { en: "Small Form Factor", es: "Formato Reducido", image: "/uploads/PHOTO-2026-05-26-09-47-44.jpg" },
  towers: { en: "Towers", es: "Torres", image: "/uploads/PHOTO-2026-05-26-11-21-11.jpg" },
  micros: { en: "Micros", es: "Micros", image: "/uploads/PHOTO-2026-05-28-14-54-02.jpg" },
  monitors: { en: "Monitors", es: "Monitores", image: "/uploads/PHOTO-2026-05-16-11-00-52.jpg" },
  parts: { en: "Parts & Accessories", es: "Partes y Accesorios", image: "/uploads/PHOTO-2026-03-25-18-46-31.jpg" },
  other: { en: "Other", es: "Otros", image: "/uploads/PHOTO-2026-05-21-09-56-47.jpg" },
};

// Ordered category list for admin dropdowns
export const CATEGORY_SLUGS = Object.keys(CATEGORY_META);

export function categoryLabel(slug, lang = "en") {
  const meta = CATEGORY_META[slug];
  if (meta) return meta[lang] || meta.en;
  // Unknown (imported) category — prettify the slug
  return String(slug || "other")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

// Resolve a stored image_url into a usable src
export function resolveImage(url, category) {
  if (!url) {
    const meta = CATEGORY_META[category] || CATEGORY_META.other;
    return meta.image;
  }
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url; // e.g. /uploads/...
}

export function formatPrice(price) {
  if (price === null || price === undefined || price === "") return null;
  const n = Number(price);
  if (Number.isNaN(n)) return null;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
